export default __webpack_public_path__ + "static/media/3.b4c0f704.jpg";